import type {MouseEvent, ReactElement} from 'react';
import React from 'react';
import {ContextualMenuInformationBox} from '@Components/contextual-menu/components/contextual-menu-information-box';
import {Text, TextSize} from '@Components/text';
import {InformationBoxType} from '@Components/contextual-menu/components/information-box';
import {AnimatePresence, motion} from 'framer-motion';
import styles from './item-lock-information-box.module.scss';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

export function ItemLockInformationBox(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const lockMovement = useGetKeyFromActiveItem('lockMovementX');

  if (!activeItem || lockMovement === undefined) {
    return null;
  }

  const onUnlock = (e: MouseEvent): void => {
    if ('href' in e.target) {
      void activeItem?.updateLock(!lockMovement);
    }
  };

  return (
    <AnimatePresence>
      {lockMovement ? (
        <motion.div layout initial={{height: 0}} animate={{height: 'auto'}} transition={{duration: 0.2}} exit={{height: 0}}>
          <ContextualMenuInformationBox containerClassName={styles.infoBox} id="item-lock-movement-info-box" type={InformationBoxType.WARNING}>
            <Text onClick={onUnlock} size={TextSize.XSMALL} val={window.i18next.t('pmwjs_item_is_locked')} dangerouslySetInnerHTML className="color-warning-dark" />
          </ContextualMenuInformationBox>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
